<mat-chip-set>
    <mat-chip *ngFor="let item of items"
              removable
              #chipTooltip="matTooltip"
              [matTooltip]="getItemLabel(item)"
              [class.st-check-list-chip-max-width-long]="asCustomField && value?.length == maxItemsToShow"
              [class.st-check-list-chip-max-width-short]="asCustomField && value?.length > maxItemsToShow"
              [class.st-check-list-chip-max-width]="asCustomField"
              (removed)="onRemove(item)"
              [disabled]="disabled">
        {{getItemLabel(item)}}
        <button matChipRemove
                [attr.aria-label]="'remove ' + item"
                [disabled]="disabled">
            <mat-icon>close</mat-icon>
        </button>
    </mat-chip>
    <mat-chip *ngIf="asCustomField && value?.length > maxItemsToShow"
              #tooltip="matTooltip"
              [matTooltip]="itemsAsTooltip"
              [matMenuTriggerFor]="listDropDownMenu"
              (menuOpened)="onMenuOpened()"
              [disabled]="disabled">
        {{ '+' + (value?.length - maxItemsToShow) + ' more' }}
    </mat-chip>
    <button mat-button
            [class.st-check-list-button-valid]="(required && value && value?.length === 0) || !value"
            [class.st-check-list-button-required]="required"
            [matMenuTriggerFor]="listDropDownMenu"
            (menuOpened)="onMenuOpened()"
            (menuClosed)="onValueChanged()"
            class="st-check-list-button"
            [disabled]="disabled">
        <span [class.st-check-list-button-label]="asCustomField"
              [class.st-check-list-button-label-long]="asCustomField && value?.length == maxItemsToShow"
              [class.st-check-list-button-label-short]="asCustomField && value?.length > maxItemsToShow">{{label ||
            placeholder}}</span>
        <mat-icon>add</mat-icon>
    </button>
</mat-chip-set>

<mat-menu #listDropDownMenu="matMenu"
          class="st-check-list-menu">
    <form click-stop-propagation
          [dir]="dir"
          class="st-check-list-form">
        <mat-form-field subscriptSizing="dynamic"
                        appearance="fill">
            <mat-icon matPrefix>search</mat-icon>
            <input #searchBox
                   type="text"
                   matInput
                   [placeholder]="appService.languageSettings.PSTWebSearchLabel"
                   [formControl]="checkListFilter">
        </mat-form-field>
        <mat-selection-list class="st-check-list-form-options"
                            [ngModel]="value"
                            click-stop-propagation
                            (selectionChange)="onSelectionChange($event)">
            <mat-list-option *ngFor="let item of filteredOptions | async"
                            [disabled]="!item?.selectable"
                             [value]="item?.id">
                {{getItemLabel(item?.id)}}
            </mat-list-option>
        </mat-selection-list>
    </form>
</mat-menu>
